import { DELETE_LIST_ITEMS_ERROR, DELETE_LIST_ITEMS_START, DELETE_LIST_ITEMS_SUCCESS } from '../../types';

export default function delete_list_items(state, action) {
  switch (action.type) {
    case DELETE_LIST_ITEMS_START:
      return { ...state };
    case DELETE_LIST_ITEMS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case DELETE_LIST_ITEMS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}